var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomborder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1914 578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #aeb4bb;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #ffde83;\r\n      }\r\n\r\n      .cls-4, .cls-18 {\r\n        mix-blend-mode: soft-light;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #343e56;\r\n      }\r\n\r\n      .cls-19 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#Gradient_3);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #080610;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #232c40;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #ffe600;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#Gradient_3-2);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #6d2f74;\r\n        mix-blend-mode: multiply;\r\n        opacity: .5;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: #242c44;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_3",
    "data-name": "Gradient 3",
    x1: 478.38,
    y1: 780.91,
    x2: 478.38,
    y2: 244.01,
    gradientTransform: "translate(0 677.59) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a0515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_3-2",
    "data-name": "Gradient 3",
    x1: -3270.26,
    x2: -3270.26,
    gradientTransform: "translate(-1834.64 677.59) rotate(-180)",
    xlinkHref: "#Gradient_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 376.76,
    y1: 430.14,
    x2: 376.76,
    y2: 401.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 446.72,
    x2: 446.72,
    y2: 402.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 956.61,
    y1: 489.87,
    x2: 956.61,
    y2: 435.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -3200.92,
    y1: 430.14,
    x2: -3200.92,
    y2: 401.89,
    gradientTransform: "translate(-1663.67) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -3130.95,
    y1: 430.14,
    x2: -3130.95,
    y2: 402.32,
    gradientTransform: "translate(-1663.67) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1902.41,
    y1: 33.66,
    x2: 1902.41,
    y2: -279.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2560.56,
    y1: 33.66,
    x2: -2560.56,
    y2: -279.68,
    gradientTransform: "translate(-2547.43) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m957,431.41s-881.54.67-884.39,2.14c-2.85,1.47-67.37-42.6-71.17-50.53-3.8-7.93,0-486.33,0-486.33h43.44l.63,200.48s-20.35,69.94-23.2,92.85c-2.85,22.91-4.75,180.66-2.37,185.94,2.37,5.29,51.24,39.22,59.31,40.98,8.07,1.76,222.36.44,226.79-1.32,4.43-1.76,27.83-19.98,34.16-22.33,6.33-2.35,419.42-5.04,430.81-2.82,11.39,2.23,27.52,21.61,32.26,24.26s153.72,0,153.72,0v16.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m957,431.41s881.54.67,884.39,2.14c2.85,1.47,67.37-42.6,71.17-50.53,3.8-7.93,0-486.33,0-486.33h-43.44l-.63,200.48s20.35,69.94,23.2,92.85c2.85,22.91,4.74,180.66,2.37,185.94-2.37,5.29-51.24,39.22-59.31,40.98-8.07,1.76-222.36.44-226.79-1.32-4.43-1.76-27.83-19.98-34.16-22.33-6.33-2.35-419.42-5.04-430.81-2.82-11.39,2.23-27.52,21.61-32.26,24.26s-153.72,0-153.72,0v16.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m1145.83,546.29s102.48-78.43,114.82-85.48c12.34-7.05,557.96,0,557.96,0,0,0-66.42,82.84-76.86,88.12-10.44,5.29-595.92-2.64-595.92-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m692.88,431.68l528.86-1.05s-56.94,50.45-72.12,56.62c-15.18,6.17-364.38,0-376.24,0s-80.5-55.57-80.5-55.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m1142.99,390.49s-6.33-1.14-35.43,24.75h47.45s1.9-19.57-12.02-24.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m770.46,390.49s6.33-1.14,35.43,24.75h-47.45s-1.9-19.57,12.02-24.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m329.75,430.14s31.33-28.81,37.5-30.14c6.17-1.32,53.14,0,53.14,0l-37.22,30.14h-53.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m399.97,430.14s31.33-28.81,37.5-30.14c6.17-1.32,53.14,0,53.14,0l-37.22,30.14h-53.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m335.93,430.14s27.52-25.51,34.64-27.27c7.12-1.76,47.01-.59,47.01-.59l-34.41,27.86h-47.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m406.15,430.14s29.65-25.07,33.69-26.83c4.03-1.76,47.45-.62,47.45-.62l-33.9,27.45h-47.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m702.69,440.54s316.63-11.16,507.83,0c0,0-54.69,45.73-60.89,46.71-6.2.98-363.97,5.39-376.24,0-12.27-5.39-70.69-46.71-70.69-46.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1584.25,430.14s-31.33-28.81-37.5-30.14c-6.17-1.32-53.14,0-53.14,0l37.22,30.14h53.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1514.03,430.14s-31.33-28.81-37.5-30.14c-6.17-1.32-53.14,0-53.14,0l37.22,30.14h53.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m1578.07,430.14s-27.52-25.51-34.64-27.27c-7.12-1.76-47.01-.59-47.01-.59l34.41,27.86h47.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m1507.85,430.14s-29.65-25.07-33.69-26.83c-4.03-1.76-47.45-.62-47.45-.62l33.9,27.45h47.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m22.32,190.03s.32-95.38.63-98.9c.32-3.52,10.75-48.03,10.75-48.03l11.81-346.89V97.17l-23.2,92.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m1807.35,474.71s-511.59-12.18-540.43-5.1c-28.83,7.09-95.85,77-95.85,77l-25.25-.33s98.11-77.55,114.82-85.48c16.71-7.93,557.96,0,557.96,0l-11.26,13.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m352.22,392.35s129.69,5.89,206.86,7.07c77.18,1.18,199.27-9.42,199.27-9.42l-406.13,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m39.77,392.35s37.11,21.78,43.75,22.43c6.64.65,157.98,2.43,157.98,2.43,0,0-158.46,3.06-161.78,2.62-3.32-.44-39.95-27.48-39.95-27.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m773.38,487.24s27.99,9.05,183.93,9.05,192.31-9.05,192.31-9.05c0,0-198.32,4.52-376.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m-.24-310.73s17.6,23.35,23.88,48.03c6.28,24.67-6.11,319.45-6.11,319.45L.51,36.04-.24-310.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m1891.37,190.03s-.32-95.38-.63-98.9c-.32-3.52-10.75-48.03-10.75-48.03l-11.81-346.89V97.17l23.2,92.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m1913.93-310.73s-17.6,23.35-23.88,48.03c-6.28,24.67,6.11,319.45,6.11,319.45l17.01-20.71.76-346.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m758.44,415.24s66.97,6.21,188.43,7.68c121.46,1.47,208.13-7.68,208.13-7.68,0,0-328.16-1.21-396.56,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1145.83,546.29s519.06,7.05,595.92,2.64c0,0-100.27,6.17-297.96,6.17s-297.96-8.81-297.96-8.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1306.19,548.2s40.81,7.37,135.23,6.9c94.42-.47,117.19-4.87,117.19-4.87l-252.41-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1221.75,430.62s50.19,25.77,65.47,26.66c15.28.89,503.56,1.47,518.74,0,15.18-1.47,51.87-26.66,51.87-26.66h-636.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1238.73,438.96c4.85-5.03,85.51,13.91,85.51,13.91,0,0-60.73,6.61-66.9,4.41-6.17-2.2-18.61-18.32-18.61-18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m1142.99,390.49l430.81,2.82s-272.02-10.57-430.81-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m769.69,480.34c-39.48-7.3,66.83-46.44,214.22-44.76,147.39,1.68,161.85,37.13,161.92,44.76.07,7.62-299.69,14.14-376.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1615.24,458.17s50.35-7.48,76.82-10.25c26.47-2.77,91.35,10.25,91.35,10.25h-168.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1168.69,399.41c-10.42,2.38,57.79,4.69,83.05,2.48,25.26-2.21-70.59-5.32-83.05-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m675.96,397.43s19.02,3.54,40.13,0c21.11-3.54-40.13,0-40.13,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1908.5-287.7s-10.81,20.65-10.81,26.43,1.81,294.92,1.81,294.92c0,0,6.23-16.39,9-24.1,2.77-7.71,0-297.25,0-297.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1904.52-279.68s5.03,227.2,1.39,296.3l-6.41,17.04s-2.48-291.44-1.81-294.92c.67-3.49,6.82-18.42,6.82-18.42Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m7.03-287.7s10.81,20.65,10.81,26.43-1.81,294.92-1.81,294.92c0,0-6.23-16.39-9-24.1-2.77-7.71,0-297.25,0-297.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m11.02-279.68S5.98-52.48,9.62,16.62l6.41,17.04s2.48-291.44,1.81-294.92c-.67-3.49-6.82-18.42-6.82-18.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1453.82,546.29c-11.28-1.9,121.46-68.84,189.97-64.02,68.51,4.82,55.54,45.21,55.54,45.21,0,0-145.85,35.59-245.51,18.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1507.85,478.41c-25.29,16.49,28.29,15.78,44.25,3.61,15.96-12.18-25.52-15.82-44.25-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1250.36,430.14c-16.61-6.68,76.82-30.78,113.67-32.7,36.85-1.93,76.82,32.64,76.82,32.64l-190.49.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m609.34,418.88c-13.65,12.17,24.4,5.54,51.39,0,26.99-5.54-47.58-3.39-51.39,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m666.59,457.28l157.45,119.95,277.62.77,155.67-120.72s-153,107.26-165.46,111.11c-12.46,3.86-251,4.31-266.44,0-15.44-4.31-158.84-111.11-158.84-111.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1799.94 483.56 1751.66 483.56 1708.64 531.66 1757.11 531.66 1799.94 483.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m1710.13,531.66s35.24-33.11,44.16-37.15c8.92-4.04,36.9-1.13,36.9-1.13l8.75-9.82h-48.28l-43.02,48.1h1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m782.42,546.29s-102.48-78.43-114.82-85.48c-12.34-7.05-557.96,0-557.96,0,0,0,66.42,82.84,76.86,88.12,10.44,5.29,595.92-2.64,595.92-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m120.9,474.71s511.59-12.18,540.43-5.1c28.83,7.09,95.85,77,95.85,77l25.25-.33s-98.11-77.55-114.82-85.48c-16.71-7.93-557.96,0-557.96,0l11.26,13.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m782.42,546.29s-519.06,7.05-595.92,2.64c0,0,100.27,6.17,297.96,6.17s297.96-8.81,297.96-8.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m622.06,548.2s-40.81,7.37-135.23,6.9c-94.42-.47-117.19-4.87-117.19-4.87l252.41-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m706.5,430.62s-50.19,25.77-65.47,26.66c-15.28.89-503.56,1.47-518.74,0-15.18-1.47-51.87-26.66-51.87-26.66h636.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m683.5,438.96c-4.85-5.03-85.51,13.91-85.51,13.91,0,0,60.73,6.61,66.9,4.41,6.17-2.2,18.61-18.32,18.61-18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m313.01,458.17s-50.35-7.48-76.82-10.25c-26.47-2.77-91.35,10.25-91.35,10.25h168.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "128.31 483.56 176.59 483.56 219.61 531.66 171.14 531.66 128.31 483.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m218.12,531.66s-35.24-33.11-44.16-37.15c-8.92-4.04-36.9-1.13-36.9-1.13l-8.75-9.82h48.28s43.02,48.1,43.02,48.1h-1.49Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomborder);
export default __webpack_public_path__ + "static/media/bottomborder.814da8a8b4ab9607e2b9153ac12687d7.svg";
export { ForwardRef as ReactComponent };